export default __webpack_public_path__ + "static/media/egypt.77a54a5d.png";